
import React, { Component, useEffect, useState } from 'react'
import logo from './CampusVRLogo.jpg'; 
import { BrowserRouter as Router, Route, Link} from 'react-router-dom';

class HomePage extends Component{
    render(){
        return(
            <div>
                
            </div>
        )
    }
}

export default HomePage;